/**
 * landing-page.tsx — Trang giới thiệu eCDP toàn màn hình (khung hiển thị bản mặc định hoặc bản quản trị tải lên — xem lib/landing.ts).
 * Không dùng router / React Query để main.tsx dựng thẳng được khi vào "/" bằng tên miền giới thiệu.
 */
import { useEffect, useState } from 'react'
import { API_BASE } from '@/lib/config'
import { appUrlFor, landingFrameSrc, type LandingState } from '@/lib/landing'

export function LandingPage() {
  const [state, setState] = useState<LandingState | null | undefined>(undefined)

  useEffect(() => {
    document.title = 'eCDP — Nền tảng AI cho toàn bộ hành trình khách hàng' // i18n-ignore: trang giới thiệu dựng trước khi i18n nạp (main.tsx), không đổi theo ngôn ngữ
    let alive = true
    fetch(`${API_BASE}/public/landing`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d: LandingState | null) => { if (alive) setState(d) })
      .catch(() => { if (alive) setState(null) }) // API không tới được → vẫn hiện bản mặc định
    return () => { alive = false }
  }, [])

  if (state === undefined) return <div className="h-dvh bg-[#f4f7ff]" aria-busy="true" />
  const src = landingFrameSrc(state, appUrlFor(window.location.hostname, window.location.origin))
  return (
    <iframe
      title="Giới thiệu eCDP" // i18n-ignore: trang giới thiệu dựng trước khi i18n nạp (main.tsx), không đổi theo ngôn ngữ
      src={src}
      className="fixed inset-0 h-full w-full border-0 bg-[#f4f7ff]"
      // Bản tải lên chạy trong sandbox (máy chủ cũng gửi CSP sandbox); bản mặc định là file của chính app.
      {...(state?.custom ? { sandbox: 'allow-scripts allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation' } : {})}
      allow="fullscreen; autoplay"
    />
  )
}
